module.exports = __webpack_public_path__ + "images/homepage-appstore.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/homepage-appstore.png
// module id = 865
// module chunks = 0